export default __webpack_public_path__ + "static/media/digital-engagment.7846e972.png";